// src/pages/Blogs/Blogs.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Blogs.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import {
  FiSearch,
  FiClock,
  FiCalendar,
  FiUser,
  FiArrowRight,
  FiTrash2,
  FiGrid,
  FiMonitor,
  FiCpu,
  FiLayers,
  FiCheckSquare,
  FiServer,
  FiRefreshCw,
  FiBookOpen,
  FiTag,
  FiX
} from 'react-icons/fi';
import { LuBrain } from 'react-icons/lu';

const Blogs = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [visibleCount, setVisibleCount] = useState(4);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  const clearFilter = () => {
    setSearchTerm('');
    setSelectedCategory('All');
  };

  const loadMore = () => {
    setIsLoadingMore(true);
    setTimeout(() => {
      setVisibleCount((prev) => prev + 4);
      setIsLoadingMore(false);
    }, 300);
  };

  const blogData = [
    {
      title: "Employee Daily Task Allocation Management System",
      content: "Track tasks and productivity using this powerful task manager tool.",
      image: require('../../assets/images/employeedailytask .jpeg'),
      date: "March 25, 2025",
      author: "Praveen Kumar B",
      category: "Software Applications",
      readTime: "3 Mins Read",
      link: "/Blogs/Blogdetail/employee-daily-task-allocation-management-system"
    },
    {
      title: "Converters App",
      content: "All-in-one converter app built for mobile and web.",
      image: require('../../assets/images/Converters App Image.png'),
      date: "April 1, 2025",
      author: "Praveen Kumar B",
      category: "Web Design",
      readTime: "4 Mins Read",
      link: "/Blogs/Blogdetail/converters-app-project"
    },
    {
      title: "RFID Based Bus Number Announce System For Blind",
      content: "Hardware project using RFID for secure and automated attendance.",
      image: require('../../assets/images/RFID Image.png'),
      date: "April 5, 2025",
      author: "Praveen Kumar B",
      category: "Hardware Projects",
      readTime: "5 Mins Read",
      link: "/Blogs/Blogdetail/rfid-based-bus-number-announce-system-for-blind"
    },
    {
      title: "To-Do List App",
      content: "Minimal design, fast performance, and full CRUD features.",
      image: require('../../assets/images/To-Do-List-App Image.png'),
      date: "April 10, 2025",
      author: "Praveen Kumar B",
      category: "Task Management",
      readTime: "4 Mins Read",
      link: "/Blogs/Blogdetail/to-do-list-app"
    },
    {
      title: "AI Powered Communication Platform for Deaf and Mute",
      content: "An intelligent platform that bridges communication for the differently-abled using AI.",
      image: require('../../assets/images/AI Powered Communication Platform.avif'),
      date: "May 30, 2025",
      author: "Praveen Kumar B",
      category: "AI & Accessibility",
      readTime: "6 Mins Read",
      link: "/Blogs/Blogdetail/ai-powered-communication-platform-for-deaf-and-mute"
    },
    {
      title: "CloudVendor App using Java Spring Boot & MySQL JDBC",
      content: "Build and manage cloud vendor data using Spring Boot backend with full CRUD and MySQL JDBC integration.",
      image: require('../../assets/images/CloudVendor App Image.png'),
      date: "June 28, 2025",
      author: "Praveen Kumar B",
      category: "Backend Development",
      readTime: "5 Mins Read",
      link: "/Blogs/Blogdetail/cloudvendor-app-using-java-springboot-using-mysql-jdbc"
    },
    {
      title: "More Blogs Coming Soon",
      content: "Stay tuned for upcoming tutorials and stories.",
      image: require('../../assets/images/More Projects Coming Soon.jpeg'),
      date: "Coming Soon",
      author: "Praveen Kumar B",
      category: "Upcoming",
      readTime: "2 Mins Read",
      link: "/Blogdetail/more-projects-coming-soon"
    },
  ];

  const categories = ['All', ...new Set(blogData.map((blog) => blog.category))];

  const filteredBlogs = blogData.filter((blog) => {
    const matchesSearch =
      blog.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      blog.content.toLowerCase().includes(searchTerm.toLowerCase()) ||
      blog.category.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory =
      selectedCategory === 'All' || blog.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const getCategoryConfig = (category) => {
    switch (category) {
      case 'All':
        return {
          bg: '#2563eb',
          icon: FiGrid,
        };
      case 'Software Applications':
        return {
          bg: '#ea580c',
          icon: FiLayers,
        };
      case 'Web Design':
      case 'Web Development':
        return {
          bg: '#7c3aed',
          icon: FiMonitor,
        };
      case 'Hardware Projects':
        return {
          bg: '#0284c7',
          icon: FiCpu,
        };
      case 'Task Management':
        return {
          bg: '#10b981',
          icon: FiCheckSquare,
        };
      case 'AI & Accessibility':
      case 'AI & ML':
        return {
          bg: '#c026d3',
          icon: LuBrain,
        };
      case 'Backend Development':
      case 'Cloud & DevOps':
        return {
          bg: '#2563eb',
          icon: FiServer,
        };
      default:
        return {
          bg: '#64748b',
          icon: FiTag,
        };
    }
  };

  return (
    <div className="blogs-page">
      {/* 1. Hero Banner */}
      <section className="blogs-hero-banner" data-aos="fade-down">
        <div className="hero-banner-overlay" />
        <div className="hero-banner-container">
          <div className="hero-text-content">
            <div className="hero-badge">
              <FiBookOpen className="hero-badge-icon" />
              <span>Blog & Insights</span>
            </div>
            <h1 className="hero-title">
              My <span className="hero-title-gradient">Blog</span>
            </h1>
            <h2 className="hero-subtitle">
              Insights, Tutorials & Project Stories
            </h2>
            <p className="hero-description">
              Explore my thoughts, learn from my experiences, and discover tutorials on web development, AI, cloud, and more.
            </p>
          </div>

          <div className="hero-creative-visual" aria-hidden="true">
            <div className="hero-doodle-container">
              <div className="hero-doodle-sparkle">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L14.5 9.5L22 12L14.5 14.5L12 22L9.5 14.5L2 12L9.5 9.5L12 2Z" fill="#38bdf8" />
                </svg>
              </div>
              <div className="hero-doodle-words">
                <span className="doodle-w1">Ideas</span>
                <span className="doodle-w2">Insights</span>
                <span className="doodle-w3">Experience</span>
                <span className="doodle-w4">Growth</span>
              </div>
              <div className="hero-mug-graphic">
                <div className="mug-steam">
                  <span></span>
                  <span></span>
                </div>
                <div className="mug-body">
                  <div className="mug-quote">
                    <span className="quote-accent">Good</span>
                    <span>Ideas</span>
                    <span className="quote-small">Build</span>
                    <span className="quote-bold">Better</span>
                    <span className="quote-highlight">Tomorrow</span>
                  </div>
                </div>
                <div className="mug-handle"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 2. Main Content Area */}
      <div className="blogs-main-wrapper">
        {/* Search & Filter Toolbar */}
        <section className="blogs-toolbar" data-aos="fade-up">
          {/* Search Box */}
          <div className="search-box-container">
            <FiSearch className="search-box-icon" />
            <input
              type="text"
              placeholder="Search blogs here..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="search-box-input"
              aria-label="Search blogs"
            />
            {searchTerm && (
              <button
                className="search-box-clear"
                onClick={() => setSearchTerm('')}
                aria-label="Clear search text"
                type="button"
              >
                <FiX />
              </button>
            )}
          </div>

          {/* Category Filter Chips */}
          <div className="category-chips-container">
            {categories.map((category) => {
              const config = getCategoryConfig(category);
              const IconComponent = config.icon;
              const isSelected = selectedCategory === category;

              return (
                <button
                  key={category}
                  onClick={() => handleCategoryChange(category)}
                  className={`category-chip ${isSelected ? 'active' : ''}`}
                  type="button"
                >
                  <IconComponent className="chip-icon" />
                  <span className="chip-label">{category}</span>
                </button>
              );
            })}
          </div>

          {/* Clear Filter Button */}
          <button
            className="clear-filter-btn"
            onClick={clearFilter}
            type="button"
            title="Reset filters and search"
          >
            <FiTrash2 className="clear-btn-icon" />
            <span>Clear Filter</span>
          </button>
        </section>

        {/* 3. Blog Cards Grid */}
        <section className="blogs-grid-section">
          {filteredBlogs.length > 0 ? (
            <div className="blogs-cards-grid">
              {filteredBlogs.slice(0, visibleCount).map((blog, index) => {
                const catConfig = getCategoryConfig(blog.category);
                const CatIcon = catConfig.icon;

                return (
                  <article
                    className="blog-card"
                    key={blog.link || index}
                    data-aos="fade-up"
                    data-aos-delay={(index % 4) * 80}
                  >
                    {/* Top Row: Category Badge & Reading Time */}
                    <div className="blog-card-top-row">
                      <span
                        className="blog-category-badge"
                        style={{ backgroundColor: catConfig.bg }}
                      >
                        <CatIcon className="badge-icon" />
                        <span>{blog.category}</span>
                      </span>
                      <span className="blog-read-time">
                        <FiClock className="read-time-icon" />
                        <span>{blog.readTime || '4 Mins Read'}</span>
                      </span>
                    </div>

                    {/* Image Area */}
                    <div className="blog-thumbnail-wrapper">
                      <img
                        src={blog.image}
                        alt={blog.title}
                        className="blog-thumbnail-img"
                        loading="lazy"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?auto=format&fit=crop&w=800&q=80';
                        }}
                      />
                    </div>

                    {/* Card Content */}
                    <div className="blog-card-body">
                      <h3 className="blog-card-title" title={blog.title}>
                        {blog.title}
                      </h3>
                      <p className="blog-card-excerpt">
                        {blog.content}
                      </p>

                      {/* Metadata: Date and Author */}
                      <div className="blog-card-meta">
                        <div className="meta-item">
                          <FiCalendar className="meta-icon" />
                          <span>{blog.date}</span>
                        </div>
                        <div className="meta-item">
                          <FiUser className="meta-icon" />
                          <span>{blog.author}</span>
                        </div>
                      </div>

                      {/* View Details Action Button */}
                      <Link to={blog.link} className="blog-view-details-btn">
                        <span className="btn-left-content">
                          <FiArrowRight className="btn-prefix-arrow" />
                          <span>View Details</span>
                        </span>
                        <span className="btn-circle-badge">
                          <FiArrowRight />
                        </span>
                      </Link>
                    </div>
                  </article>
                );
              })}
            </div>
          ) : (
            /* Empty State */
            <div className="blogs-empty-state" data-aos="fade-up">
              <div className="empty-state-icon-box">
                <FiSearch className="empty-state-icon" />
              </div>
              <h3 className="empty-state-title">No Blogs Found</h3>
              <p className="empty-state-text">
                {searchTerm
                  ? `We couldn't find any blogs matching "${searchTerm}".`
                  : `No blogs currently found in "${selectedCategory}".`}
              </p>
              <button className="empty-state-reset-btn" onClick={clearFilter} type="button">
                <FiRefreshCw className="reset-btn-icon" />
                <span>Clear All Filters</span>
              </button>
            </div>
          )}

          {/* 4. Load More Button Section */}
          {visibleCount < filteredBlogs.length && (
            <div className="blogs-load-more-container" data-aos="fade-up">
              <div className="load-more-accent-left" aria-hidden="true">
                <span className="accent-ray r1"></span>
                <span className="accent-ray r2"></span>
                <span className="accent-ray r3"></span>
              </div>

              <button
                className={`blogs-load-more-btn ${isLoadingMore ? 'loading' : ''}`}
                onClick={loadMore}
                disabled={isLoadingMore}
                type="button"
                aria-label="Load more blogs"
              >
                <FiRefreshCw className={`load-more-icon ${isLoadingMore ? 'spinning' : ''}`} />
                <span className="load-more-text">
                  {isLoadingMore ? 'Loading Blogs...' : 'Load More Blogs'}
                </span>
                <FiArrowRight className="load-more-arrow" />
              </button>

              <div className="load-more-accent-right" aria-hidden="true">
                <span className="accent-ray r1"></span>
                <span className="accent-ray r2"></span>
                <span className="accent-ray r3"></span>
              </div>
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

export default Blogs;
